import React, { useState, useEffect } from 'react';
import { find } from 'lodash';
import moment from 'moment';
import { getValuePath, isTemplateMode, isPreviewMode, isTemplateToolMode } from '@/utils/tool';
import { getEnumList } from '@/services/dict';
import ConfirmComps from './components/index.js'; // 证件有效期

const transFormCertValidatePeriod = val => val === '9999-12-31' ? '长期' : val;

const transformDate = val => val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';

const transFormPerid = itemValue => {
  if (itemValue && typeof itemValue === 'string' && itemValue.indexOf('-') !== -1) {
    const arr = itemValue.split('-');
    const list = {
      Y: '年',
      D: '天'
    };

    if (arr[1] === 'L') {
      return '终身';
    }

    const value = arr[0] + list[arr[1]];
    return value;
  }

  return '';
};

const tansFormNationality = (value, dataSource = [], key) => {
  const valueItem = find(dataSource, item => item.code === value);
  return valueItem ? valueItem.name : value;
};

const transFormFn = {
  certValidatePeriod: transFormCertValidatePeriod,
  insuranceStartDate: transformDate,
  insuranceEndDate: transformDate,
  insurancePeriod: transFormPerid,
  nationality: tansFormNationality
}; // value用户录入的值
// dataSource 枚举项数据
// key 用户录入的表单key 也是配置的要素code

export const transFormValue = (value, dataSource = [], key) => {
  if (key && transFormFn[key]) {
    return transFormFn[key](value, dataSource, key);
  }

  if (dataSource && dataSource.length === 0) {
    return value;
  }

  const valueItem = find(dataSource, item => item.value === value);
  return valueItem ? valueItem.label : value;
}; // itemValue, 确认项的值
// dataSource = [], // 确认项枚举值
// itemKey, // 表单key
// itemlabel // 确认项

export const DetailItem = props => {
  const {
    itemValue,
    dataSource = [],
    itemKey,
    itemlabel
  } = props;
  const [data, setData] = useState('');
  useEffect(() => {
    setData(transFormValue(itemValue, dataSource, itemKey));
  }, [itemValue]);

  if (itemKey === 'occupation' && itemValue) {
    // 职业 && 职业改为显示所有层级
    if (!isTemplateMode() && !isPreviewMode() && !isTemplateToolMode()) {
      getEnumList('occupation').then(res => {
        if (res.success) {
          const valuePath = getValuePath(itemValue, res.result, 'code');

          if (valuePath && valuePath.length) {
            let name = '';
            valuePath === null || valuePath === void 0 ? void 0 : valuePath.forEach((v, i) => {
              if (i === valuePath.length - 1) {
                name += v.name;
              } else {
                name += `${v.name}-`;
              }
            });
            setData(name);
          }
        }
      });
    }
  }

  if ((itemKey === 'region' || itemKey === 'insureRegion') && itemValue) {
    // 省市区
    getEnumList('district').then(res => {
      if (res.success) {
        const codeArr = itemValue.split(',');
        const valuePath = getValuePath(codeArr[codeArr.length - 1], res.result, 'code');

        if (valuePath && valuePath.length) {
          setData(valuePath.map(item => item.name).join('/'));
        }
      }
    });
  } // 解决开户银行枚举对不上的bug && 鲸小保


  if (itemKey === 'bankCode' && itemValue) {
    // 省市区
    getEnumList('bank').then(res => {
      const {
        success,
        message,
        result
      } = res;

      if (success) {
        result === null || result === void 0 ? void 0 : result.forEach(item => {
          if ((item === null || item === void 0 ? void 0 : item.code) === itemValue) {
            setData(item === null || item === void 0 ? void 0 : item.name);
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        Toast.show(message);
      }
    });
  }

  const unitList = ['premium'];
  let _data = data;

  if (unitList.includes(itemKey)) {
    _data = isNaN(_data) ? '' : `${_data} 元`;
  }

  const ConformComp = ConfirmComps[itemKey];

  if (ConfirmComps[itemKey]) {
    return /*#__PURE__*/React.createElement(ConformComp, props);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, itemlabel, ":"), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, _data));
};